import axios from "./Interceptors";
import { TCF_URL } from "./URLs";

const login = async (payload) => {
    return await axios.post(TCF_URL.USER_LOGIN, payload);
}

const registeration = async (payload) => {
    return await axios.post(TCF_URL.USER_REGISTRATION, payload);
}

const resendVerificationEmail = async (payload) => {
    return await axios.post(TCF_URL.RESEND_VERIFICATION_EMAIL, payload)
}

const accountVerification = async (token) => {
    return await axios.get(TCF_URL.RESEND_VERIFICATION_EMAIL(token))
}

const forgotPassword = async (payload) => {
    return await axios.post(TCF_URL.FORGOT_PASSWORD, payload)
}

const resetPassword = async (payload) => {
    return await axios.post(TCF_URL.PASSWORD_RESET, payload)
}

const validatePasswordToken = async (payload, token) => {
    return await axios.post(TCF_URL.VERIFY_PASSWORD_TOKEN(token), payload)
}

const validateToken = async () => {
    return await axios.get(TCF_URL.VALIDATE_TOKEN)
}

const checkEmailExists = async (payload) => {
    return await axios.post(TCF_URL.CHECK_EMAIL_EXIST, payload)
}

const fetchUserDetails = async () => {
    return await axios.get(TCF_URL.GET_USER_DATA)
}

const getUserTotalDonation = async (userId) => {
    return await axios.get(TCF_URL.GET_USER_TOTAL_DONATIONS(userId))
}

const getUserDonationHistory = async (payload) => {
    if(payload.search_string == ''){
        payload.search_string = null;
    }
    return await axios.get(TCF_URL.GET_USER_DONATION_HISTORY(payload.offset,payload.limit,payload.search_string,payload.sort_by))
}

const getUserRecentDonations = async (userId, limit) => {
    return await axios.get(TCF_URL.GET_USER_RECENT_DONATIONS(userId, limit))
}

const getUserActivities = async (payload) => {
    return await axios.post(TCF_URL.GET_USER_ACTIVITIES, payload)
}

const getUserGraphData = async (payload) => {
    return await axios.post(TCF_URL.GET_USER_GRAPH_DATA, payload)
}

const getUserDetails = async (userId) => {
    return await axios.get(TCF_URL.GET_USER_DETAILS(userId))
}

const getActiveUsers = async (payload) => {
    return await axios.post(TCF_URL.GET_ALL_ACTIVE_USERS, payload)
}

const getUserCurrency = async () => {
    return await axios.get(TCF_URL.GET_USER_CURRENCY)
}

const getUserIP = async () => {
    return await axios.get('https://geolocation-db.com/json/')
}
export const userAPIs = {
    login,
    registeration,
    resendVerificationEmail,
    accountVerification,
    forgotPassword,
    resetPassword,
    validatePasswordToken,
    validateToken,
    checkEmailExists,
    fetchUserDetails,
    getUserTotalDonation,
    getUserDonationHistory,
    getUserRecentDonations,
    getUserActivities,
    getUserGraphData,
    getUserDetails,
    getActiveUsers,
    getUserCurrency,
    getUserIP
}
